import React from "react";
import { createPortal } from "react-dom";
import { FaTimes, FaLightbulb, FaArrowRight } from "react-icons/fa";

const GuidancePopup = ({ isOpen, onClose, onOpenWhatNew }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/60 backdrop-blur-md p-4 animate-fade-in">
      <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-2xl w-full max-w-[450px] overflow-hidden animate-scale-in border border-gray-100 dark:border-dark-700">
        
        {/* Decorative Header */}
        <div className="h-2 bg-gradient-to-r from-primary-400 via-primary-500 to-primary-600" />
        
        <div className="p-8 text-center relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
          >
            <FaTimes className="w-4 h-4" />
          </button>

          <div
            className="w-20 h-20 mx-auto mb-6 rounded-3xl flex items-center justify-center shadow-xl relative group animate-bounce-slow"
            style={{
              background: `linear-gradient(135deg, var(--primary-500), var(--primary-600))`,
              boxShadow: `0 15px 30px -5px var(--primary-500)40`
            }}
          >
            <FaLightbulb className="w-10 h-10 text-white relative z-10" />
            <div className="absolute inset-0 bg-white/20 rounded-3xl blur-md opacity-0 group-hover:opacity-100 transition-opacity" />
          </div>

          <h2 className="text-2xl font-black text-dark-800 dark:text-white tracking-tight mb-3">
            Guidance
          </h2>
          
          <p className="text-gray-600 dark:text-gray-400 leading-relaxed mb-8">
            Check out our latest newsletters and e-books to stay updated with the US business ecosystem and important community updates.
          </p>

          <div className="space-y-3">
            <button
              onClick={() => {
                onOpenWhatNew();
                onClose();
              }}
              className="w-full py-4 rounded-xl font-bold text-white shadow-lg transition-all duration-300 flex items-center justify-center gap-2 text-base hover:scale-[1.02] active:scale-[0.98] group"
              style={{
                background: `linear-gradient(135deg, var(--primary-500), var(--primary-600))`,
                boxShadow: `0 8px 15px -3px var(--primary-500)50`
              }}
            >
              Open 
              <FaArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
            
            <button
              onClick={onClose}
              className="w-full py-2 rounded-lg font-bold text-gray-400 dark:text-gray-500 hover:text-primary-500 dark:hover:text-primary-400 transition-all duration-200 text-sm"
            >
              Maybe Later
            </button>
          </div>
        </div>

        {/* Footer info */}
        <div className="px-8 py-4 bg-gray-50 dark:bg-dark-900/50 border-t border-gray-100 dark:border-dark-700/50 text-center">
          <p className="text-[10px] text-gray-400 dark:text-gray-500 uppercase font-bold tracking-[0.1em]">
            Stay ahead with BooksComply Resources
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default GuidancePopup;
